import { HomeTemplate } from 'infrastructure/components';

const Home = () => {
  return <HomeTemplate />;
};

export default Home;
